import gql from 'graphql-tag';
import apollo from 'src/features/apollo';

const query = gql`
query UcceIntegration {
  ucceIntegration {
    enable
  }
}`;

function getUcceIntegration() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.ucceIntegration);
}

export default getUcceIntegration;
